import { render } from "./OrderCustomsListPage.vue?vue&type=template&id=b3cea97e"
import script from "./OrderCustomsListPage.vue?vue&type=script&lang=js"
export * from "./OrderCustomsListPage.vue?vue&type=script&lang=js"
script.render = render

export default script